const TextAreaInput = (props) => {
    return (
        <textarea
            className='focus:outline-1 focus:outline-accent py-2.5 px-3 gap-2.5 self-stretch border rounded mt-1.5 font-montserrat border-neutral5 min-h-[6.25rem]'
            id={props.id} 
            type={props.type}
            value={props.value}
            placeholder={props.placeholder}
            onChange={props.onChange}
        />
    )
}

export default TextAreaInput